import { render } from "./StackedBarChartCanvas.vue?vue&type=template&id=8daffa00"
import script from "./StackedBarChartCanvas.vue?vue&type=script&lang=js"
export * from "./StackedBarChartCanvas.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__